export const PINK_COLOR = '#AD01B9';
export const ORANGE_COLOR = '#FFBC00';
export const WHITE_COLOR = '#FFFFFF';
export const BLACK_COLOR = '#000000';
export const BRAND_COLOR = '#6414DB';
export const LIGHT_GREY = '#F6F6F6';
export const DEFAULT_COLOR = '#C7C6C6';
export const GREEN_COLOR = 'rgb(21, 120, 70)';
